import { render, staticRenderFns } from "./markBoard.vue?vue&type=template&id=87c37428&scoped=true&"
import script from "./markBoard.vue?vue&type=script&lang=js&"
export * from "./markBoard.vue?vue&type=script&lang=js&"
import style0 from "./markBoard.vue?vue&type=style&index=0&id=87c37428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c37428",
  null
  
)

export default component.exports